import themable from '_uikit/_themable'

export const Default = themable('PeopleDefaultTile')

export default { Default }
